<template>
  <div>
    <a-spin :spinning="tcgaLoading" :indicator="indicator">
      <vxe-toolbar>
        <template #buttons>
          <vxe-input
            v-model="filterName_detable"
            type="search"
            placeholder="Input a key word"
            @keyup="searchEvent_detable"
          ></vxe-input>
          <vxe-button @click="exportDataEvent"
            ><a-icon type="cloud-download" /> Download</vxe-button
          >
        </template>
      </vxe-toolbar>
      <vxe-table
        border
        show-overflow
        row-id="id"
        size="small"
        ref="xTable"
        :data="tableData_detable"
        class="my-sort"
        align="center"
        header-align="center"
        :row-style="rowStyle"
        :column-config="{ isHover: true }"
        :row-config="{ isCurrent: true, isHover: true }"
        :sort-config="{
          showIcon: false,
          trigger: all,
        }"
        @header-cell-click="headerCellClickEvent"
      >
        <vxe-column field="cancer" title="Cancer" type="html"> </vxe-column>
        <!-- <vxe-column field="statistic" title="Statistic" type="html">
          <template #default="{ row }">
            {{ Number.parseFloat(row.statistic).toPrecision(3) }}
          </template></vxe-column
        > -->
        <vxe-column field="log2fc" title="Log2FC" sortable>
          <template #default="{ row }">
            {{ Number.parseFloat(row.log2fc).toPrecision(3) }}
          </template>

          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span>
          </template>
        </vxe-column>
        <vxe-column field="pvalue" title="P-value" sortable>
          <template #default="{ row }">
            {{ Number.parseFloat(row.pvalue).toPrecision(3) }}
          </template>
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span>
          </template>
        </vxe-column>
        <vxe-column field="Show" title="View" type="html">
          <template #default="{ row }">
            <div v-if="row.mk == 2" @click="showPDF(row.cancer, row.pvalue)">
              <a-button type="danger" shape="circle" icon="search" />
            </div>
            <div v-if="row.mk == 1" @click="showPDF(row.cancer, row.pvalue)">
              <a-button type="primary" shape="circle" icon="search" />
            </div>
            <div v-if="row.mk == 0" @click="showPDF(row.cancer, row.pvalue)">
              <a-button type="dashed" shape="circle" icon="search" />
            </div>
          </template>
        </vxe-column>
        <template #empty>
          <span style="color: grey"> No more data! </span>
        </template>
      </vxe-table>

      <vxe-pager
        background
        size="small"
        :loading="tcgaLoading"
        :current-page="tablePage_detable.currentPage"
        :page-size="tablePage_detable.pageSize"
        :total="tablePage_detable.totalResult"
        :page-sizes="[12]"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          // 'FullJump',
          //   'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange_table"
      >
      </vxe-pager>
    </a-spin>
    <a-modal
      :visible="this.modal"
      :maskClosable="false"
      :keyboard="false"
      :closable="true"
      :width="800"
      style="margin-top: 300px"
      :footer="null"
      @cancel="handleOk"
    >
      <div slot="title">TCGA based on sample types</div>
      <div slot="cancelText">
        <a-icon type="cloud-download" />
      </div>
      <TCGAboxplotModal
        v-bind:ensgId="this.ensgId"
        v-bind:selectCa="this.selectCancer"
        v-bind:pvalue="this.pvalue"
      />
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import XEUtils from "xe-utils";
import TCGAboxplotModal from "./TCGAboxplotModal.vue";

export default {
  props: ["searchgene"],
  components: { TCGAboxplotModal },
  created() {
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/perturbGene_basic.php",
        {
          params: {
            genename: this.searchgene,
          },
        }
      )
      .then((response) => {
        //同一转一下.
        this.gene = response.data[0]["genename"];
        this.ensgId = response.data[0]["ensgId"];
        this.genetype = response.data[0]["genetype"];
        this.alias = response.data[0]["alias"]
          .replaceAll("|", ",")
          .substring(
            1,
            response.data[0]["alias"].replaceAll("|", ",").length - 1
          );
        this.geneId = response.data[0]["geneid"];
        this.genetag = response.data[0]["genetag"];
        this.summary = response.data[0]["summary"];
        this.fullname = response.data[0]["fullname"];
        this.localization = response.data[0]["localization"];
        this.uniprot = response.data[0]["uniprot"];
        axios
          .get(
            "http://research.gzsys.org.cn/perturbdb/API/TCGA/search_diffMessage.php",
            {
              params: {
                ensgId: this.ensgId,
              },
            }
          )
          .then((response) => {
            const convertedArray = [...response.data].sort(
              (a, b) => b.mk - a.mk
            );
            this.getdata_detable = convertedArray;
            this.findList_detable(this.getdata_detable);
            this.tcgaLoading = false;
          });
        //TCGA diffNum
        axios
          .get(
            "http://research.gzsys.org.cn/perturbdb/API/TCGA/search_diffNum.php",
            {
              params: {
                ensgId: this.ensgId,
              },
            }
          )
          .then((response2) => {
            this.diffcancer = response2.data;
          });
      });
  },
  methods: {
    headerCellClickEvent({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter,
    }) {
      // 如果触发了列的其他功能按钮
      console.log(column["field"]);
      if (
        column.sortable &&
        !(triggerResizable || triggerSort || triggerFilter)
      ) {
        this.tcgaLoading = true;
        if (column.order === "desc") {
          axios
            .get(
              "http://research.gzsys.org.cn/perturbdb/API/TCGA/search_diffMessage.php",
              {
                params: {
                  ensgId: this.ensgId,
                },
              }
            )
            .then((response) => {
              const convertedArray = [...response.data].sort(
                (a, b) => b.mk - a.mk
              );
              this.getdata_detable = convertedArray;
              this.$refs.xTable.clearSort();
              this.findList_detable(this.getdata_detable);
              this.tcgaLoading = false;
            });
        } else if (column.order === "asc") {
          this.$refs.xTable.sort(column.property, "desc");
          var jiangxu = this.getdata_detable.sort(
            (a, b) => b[column.field] - a[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = jiangxu;
          this.findList_detable(this.getdata_detable);
          this.tcgaLoading = false;
        } else {
          this.$refs.xTable.sort(column.property, "asc");
          //var field = column.field;
          var shengxu = this.getdata_detable.sort(
            (a, b) => a[column.field] - b[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = shengxu;
          this.findList_detable(this.getdata_detable);
          this.tcgaLoading = false;
        }
      }
    },
    formatAmount({ cellValue }) {
      return XEUtils.commafy(XEUtils.toNumber(cellValue));
    },
    rowStyle({ row }) {
      if (row.mk == 2) {
        return {
          backgroundColor: "#AA4643",
          color: "#ffffff",
        };
      } else if (row.mk === 1) {
        return {
          backgroundColor: "#4572a7",
          color: "#ffffff",
        };
      }
    },
    showPDF(value1, value2) {
      this.modal = true;
      this.selectCancer = value1;
      this.pvalue = Number.parseFloat(value2).toPrecision(4);
      console.log(value2);
    },
    changeData(value) {
      this.marker = value;
      this.getdata_detable = this.gsea[value];
      this.findList_detable(this.getdata_detable);
    },
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename: "Pan-cancer_DE_of_" + this.$route.query.gene,
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
          columns: ["cancer", "log2fc", "pvalue"],
        });
      } else {
        const list = this.tempdata_detable;
        this.$refs.xTable.exportData({
          filename:
            this.filterName_detable +
            "_related_Pan-cancer_DE_of_" +
            this.$route.query.gene,
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
          columns: ["cancer", "log2fc", "pvalue"],
        });
      }
    },
    handleOk() {
      this.modal = false;
    },
    handleCancel() {
      // 创建一个隐藏的 <a> 元素
      var link = document.createElement("a");
      link.style.display = "none";

      // 设置文件的下载链接

      link.href = this.url;

      link.setAttribute(
        "download",
        this.methods + "_" + this.url.split("/").pop()
      );

      // 将 <a> 元素添加到文档中
      document.body.appendChild(link);

      // 模拟点击事件
      link.click();

      // 清理
      document.body.removeChild(link);
    },
    findList_detable(data) {
      this.tcgaLoading = true;
      setTimeout(() => {
        const list = data;
        this.tcgaLoading = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1;
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["cancer"];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        this.tempdata_detable = [];
        this.findList_detable(this.getdata_detable);
      }
    },
    hideInhibitors() {
      this.visibleInhibitor = false;
    },
    hideScore() {
      this.visibleScore = false;
    },
    downloadRDS() {
      // 创建一个隐藏的 <a> 元素
      var link = document.createElement("a");

      link.style.display = "none";

      // 设置文件的下载链接
      link.href =
        "http://research.gzsys.org.cn/perturbdb/data/publications/" +
        this.$route.query.datasetId +
        "/split_rdata/" +
        this.$route.query.gene +
        ".rds";

      link.setAttribute("download", this.$route.query.gene + ".rds");

      // 将 <a> 元素添加到文档中
      document.body.appendChild(link);

      // 模拟点击事件
      link.click();

      // 清理
      document.body.removeChild(link);
    },
    changeHash(idname) {
      document.querySelector(idname).scrollIntoView({
        inline: "nearest",
        behavior: "smooth",
      });
    },
  },
  data() {
    return {
      svgSrc:
        "http://research.gzsys.org.cn/perturbdb/data/publications/" +
        this.$route.query.datasetId +
        "/batchPlot/" +
        this.$route.query.gene +
        ".score.png",
      //basic infor
      gene: "",
      ensgId: "",
      genetype: "",
      alias: "",
      geneId: "",
      genetag: "",
      summary: "",
      fullname: "",
      localization: "",
      uniprot: "",
      //perturbatuon rate
      PR: "",
      // 是否能形成 PC
      isPC: false,
      pcLinks: "",
      pcplot: null,
      //pcplot:
      // "http://research.gzsys.org.cn/perturbdb/data/clusters/result_plot/" +
      // this.$route.query.pcID +
      // ".pdf",
      //帮助弹窗
      visibleInhibitor: false,
      visibleScore: false,
      visibleDE: false,
      //TCGA
      diffcancer: 0,
      //oncoPheno
      showOncoPheno: "No",
      // 弹窗
      modal: false,
      selectCancer: "",
      pvalue: 0,
      //加载
      spinning: false,
      indicator: <a-icon type="loading" style="font-size: 50px" spin />,
      //全表搜索
      tcgaLoading: true,
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 12,
        totalResult: 0,
      },
    };
  },
};
</script>

<style></style>
